import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import Order from '../../../records/Order';
import { translate as t } from '../../../lib/I18n';
import { getBrandInfo } from '../../../lib/brand';

import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import PureRenderComponent from '../../PureRenderComponent';

class DeliveryInformationCollection extends PureRenderComponent {

    static propTypes = {
        order: PropTypes.instanceOf(Order).isRequired
    };

    render () {
        const { order } = this.props;
        const { delivery } = order;
        const { isGTR } = getBrandInfo();
        const deliveryTimeInMinutes = isGTR ? 5 : 30;

        return (
            <Row>
                <Col xs={ 12 }>
                    <div>
                        { order.collectionReference && <p className="text-primary text-weight--normal text-lg">
                            { t('order.details.collectionreference', { ref: order.collectionReference }) }
                            <span className="sr-only">. </span>
                        </p> }
                        <p>
                            <FormattedHTMLMessage message={t("order.details.todWithAnyCard", { stationName: delivery.collectionLocation.name, ref: order.collectionReference, deliveryTime: deliveryTimeInMinutes })} />
                        </p>
                    </div>
                </Col>
            </Row>
        );
    }
}

export default DeliveryInformationCollection;



// WEBPACK FOOTER //
// ./src/components/checkout/orderSummary/DeliveryInformationCollection.js